import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import {
  type PatchCertificateItemsPayload,
  type PatchCertificateItemsResponse,
  patchAtolCertificateItems,
} from '~/services/TravelComplianceService';

import { atolCertificateQueryKeys } from './atolCertificateQueryKeys';

interface PatchParams {
  payload: PatchCertificateItemsPayload;
  dryRun: boolean;
}

export function usePatchAtolCertificateItems(certificateId: string) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<PatchCertificateItemsResponse, Error, PatchParams>({
    mutationFn: ({ payload, dryRun }: PatchParams) => patchAtolCertificateItems(payload, dryRun),
    onSuccess: (_data, variables) => {
      if (!variables.dryRun) {
        queryClient.invalidateQueries({ queryKey: atolCertificateQueryKeys.detail(certificateId) });
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to update certificate: ${error.message}`, { variant: 'error' });
    },
  });
}
